import {Profile} from "@/store/profile/types";
import {Player} from "@/store/player/types";
import http from "@/axios";
import PlayerStore from "@/store/player";

export default class ProfileStore {

    public static setProfileSeen(): Promise<Player> {
        return http.post('/api/profile/set/seen')
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

    public static fetchMyProfile(): Promise<Profile> {
        return http.get('/api/profile/my')
            .then(r => r.data)
            .then(profileObj => {
                return Object.assign(new Profile(), profileObj);
            })
    }

    public static fetchProfileByPlayerId(playerId: number): Promise<Profile> {
        return http.get('/api/profile/id/' + playerId)
            .then(r => r.data)
            .then(profileObj => {
                return Object.assign(new Profile(), profileObj);
            })
    }

}
